/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Generated by vite-plugins/prodeng-routes.ts
 * Source: content/prodeng/2026-02-20_the-air-traffic-controller-problem.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { ProdEngArticleLayout } from '@/components/ProdEngArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/prodeng/the-air-traffic-controller-problem.mdx';

const metadata = {
  title: "The Air Traffic Controller Problem: Every Team Needs One",
  date: "2026-02-20",
  author: "Christian Battaglia",
  articleNumber: 6,
  seoDescription: "Coordination overhead, not talent, is the constraint. Every function needs an air traffic controller who sees the whole system and picks the right boundary.",
  linkedinUrl: "https://www.linkedin.com/pulse/air-traffic-controller-problem-every-team-needs-one-battaglia-usigc",
  heroImage: "/prodeng/the-air-traffic-controller-problem.webp",
  readTime: "22 min read",
  tags: ["product engineering","coordination","systems thinking","organizational design","leadership","engineering management","software engineering","communication"],
  published: true,
};

export const Route = createFileRoute('/prodeng/articles/the-air-traffic-controller-problem')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title} — Product Engineering`,
    description: metadata.seoDescription || '',
    path: '/prodeng/articles/the-air-traffic-controller-problem',
    image: '/og/prodeng/the-air-traffic-controller-problem.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    authorName: metadata.author,
    readTime: metadata.readTime,
    tags: metadata.tags,
    section: 'Product Engineering',
  }),
});

function ArticlePage() {
  return (
    <ProdEngArticleLayout {...metadata}>
      <Content />
    </ProdEngArticleLayout>
  );
}
